import Vue from 'vue'
// 用于BUS总线传值

Vue.prototype.$eventBus = new Vue;



// WEBPACK FOOTER //
// ./src/utils/eventBus.js